/* eslint-disable */
import { ParsePromotionalBadges } from "@auer-steel/Handlers/Utilities";
import {
    getProductReplacementProductsWithResult,
} from "@auer-steel/Services/ProductReplacementProductService";
import { getProductPromotionsWithResult } from "@auer-steel/Services/PromotionService";
import { getProductSubscriptionWithResult } from "@auer-steel/Services/SubscriptionService";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";

replaceInChain(chain, PopulateApiParameter, props => {
    props.apiParameter = {
        ...props.parameter,
        expand: ["detail", "specifications", "content", "images", "documents", "attributes", "variantTraits", "badges", "properties"],
        includeAttributes: ["includeOnProduct"],
    };
});

addToChainAfter(chain, RequestDataFromApi, async function (props) {
    //AST-166
    ParsePromotionalBadges(props.apiResult);
});

addToChainAfter(chain, RequestDataFromApi, async function (props) {
    const subscriptionInformation = await getProductSubscriptionWithResult(props.apiResult.productNumber);
    props.apiResult.userIsSubscribed = subscriptionInformation.toString() != "";
});

addToChainAfter(chain, RequestDataFromApi, async function (props) {
    //if (props.apiResult.isDiscontinued) {
        const replacementProductInformation = await getProductReplacementProductsWithResult(
            props.apiResult.id,
        );
        console.log(replacementProductInformation);
        props.apiResult.replacementProductNumber = replacementProductInformation;
    //}
});

addToChainAfter(chain, RequestDataFromApi, async function (props) {
    // AST-43
    if (props.apiResult) {
        const promotions = await getProductPromotionsWithResult(props.apiResult.id);
        const result = JSON.parse(promotions);
        props.apiResult.promotions = result["promotions"];
    }
});